/**
 * business.js — 경영공학대학 이수요건 데이터
 * 출처: 2026학년도 전공 교육과정 (2026_major.pdf)
 *
 * 1학년 1학기 전공필수: 경영학원론, 경제학원론
 * 1학년 1학기 기초교양: AI활용ESL1, AI활용CSL1, AI활용글쓰기
 * 1학년 2학기 필수: 전공진로세미나1, 글로벌비즈니스론, 회계원리, 서비스경영론
 */

export const BUSINESS_REQUIREMENTS = [

  // ── 경영공학학부 / 2026학번 / 1학년 1학기 ────────────────────────────────────────
  {
    id:             'business_admin_2026_1_1',
    collegeId:      'business_engineering',
    collegeName:    '경영공학대학',
    departmentId:   'business',
    departmentName: '경영공학학부',
    majorId:        'business_admin',
    majorName:      '경영학전공',
    admissionYear:  2026,
    grade:          1,
    semester:       1,
    status:         'official',
    requiredCourses: [
      { courseName: '경영학원론',    courseCode: '00546', type: '전공필수', credits: 3, required: true, matchKeywords: ['경영학원론'] },
      { courseName: '경제학원론',    courseCode: '00591', type: '전공필수', credits: 3, required: true, matchKeywords: ['경제학원론'] },
      { courseName: 'AI활용ESL1',   courseCode: '11788', type: '기초교양', credits: 3, required: true, matchKeywords: ['AI활용ESL1', 'ESL1'] },
      { courseName: 'AI활용CSL1',   courseCode: '11790', type: '기초교양', credits: 3, required: true, matchKeywords: ['AI활용CSL1', 'CSL1'] },
      { courseName: 'AI활용글쓰기', courseCode: '11792', type: '기초교양', credits: 3, required: true, matchKeywords: ['AI활용글쓰기'] },
    ],
    recommendedCourses: [],
    graduationRules: {
      totalCredits:         130,
      majorRequiredCredits: 27,
      majorElectiveCredits: 45,
      liberalArtsCredits:   null,
    },
    notes: ['2026학년도 전공 교육과정 기준 공식 데이터'],
  },

  // ── 경영공학학부 / 2026학번 / 1학년 2학기 ────────────────────────────────────────
  {
    id:             'business_admin_2026_1_2',
    collegeId:      'business_engineering',
    collegeName:    '경영공학대학',
    departmentId:   'business',
    departmentName: '경영공학학부',
    majorId:        'business_admin',
    majorName:      '경영학전공',
    admissionYear:  2026,
    grade:          1,
    semester:       2,
    status:         'official',
    requiredCourses: [
      { courseName: '전공진로세미나1', courseCode: '11415', type: '전취', credits: 1, required: true, matchKeywords: ['전공진로세미나1'] },
      { courseName: '글로벌비즈니스론', courseCode: '12436', type: '전공필수', credits: 3, required: true, matchKeywords: ['글로벌비즈니스론'] },
      { courseName: '회계원리',       courseCode: '07661', type: '전공필수', credits: 3, required: true, matchKeywords: ['회계원리'] },
      { courseName: '서비스경영론',   courseCode: '10042', type: '전공필수', credits: 3, required: true, matchKeywords: ['서비스경영론'] },
    ],
    recommendedCourses: [],
    graduationRules: {
      totalCredits:         130,
      majorRequiredCredits: 27,
      majorElectiveCredits: 45,
      liberalArtsCredits:   null,
    },
    notes: ['2026학년도 전공 교육과정 기준 공식 데이터'],
  },

  // ── 경영공학학부 / 2025학번 / 2학년 1학기 ────────────────────────────────────────
  {
    id:             'business_admin_2025_2_1',
    collegeId:      'business_engineering',
    collegeName:    '경영공학대학',
    departmentId:   'business',
    departmentName: '경영공학학부',
    majorId:        'business_admin',
    majorName:      '경영학전공',
    admissionYear:  2025,
    grade:          2,
    semester:       1,
    status:         'official',
    requiredCourses: [
      { courseName: '마케팅원론',   courseCode: '02182', type: '전공필수', credits: 3, required: true, matchKeywords: ['마케팅원론'] },
      { courseName: '인적자원관리', courseCode: '08835', type: '전공필수', credits: 3, required: true, matchKeywords: ['인적자원관리'] },
    ],
    recommendedCourses: [],
    graduationRules: {
      totalCredits:         130,
      majorRequiredCredits: 27,
      majorElectiveCredits: 45,
      liberalArtsCredits:   null,
    },
    notes: ['2026학년도 전공 교육과정 기준 공식 데이터 (경영학전공 2학년 전공핵심)'],
  },
]
